enum CueFont {
    DEFAULT
}

export default CueFont;